import React, { useContext , useState } from "react";
// import { LangContext } from "./Language/LangContext";
import './LangBtn.css';

function LangBtn({click, lang, handleLanguageChangeA, handleLanguageChangeB}) {
      const [press, setPress] = useState(false);

          const handlesClick = () => setPress(!press);
// const LangBtn = (props) => {
//     const [press, setPress] = useState(false);
//     const handlesClick = () => setPress(!press);

//     lang ?  console.log(lang) : console.log(lang);

  return (
    <>
    <div className={press ? 'sm:absolute sm:-top-16  md:top-[-5.8rem] sm:left-[60%] lg:flex  lg:relative lg:top-[0.1rem] lg:left-10  xl:top-[0.1rem] xl:left-10' 
     : 'sm:absolute sm:-top-16 md:top-[-5.8rem] sm:left-[50%] lg:flex lg:relative lg:top-[0.1rem] lg:left-10 xl:top-[0.1rem] xl:left-10'} >
      
      
        <button onClick={handlesClick}  className =' border-[4px] text-lg md:text-[1.6rem] lg:text-xl btn lg:block font-medium ml-4 xl:ml-5 lang-btn lg:border-lightBlack px-4 py-1  lg:px-4 lg:py-1 md:px-5 md:py-[0.7rem] rounded-lg z-40 sm:border-orange  sm:text-gray lg:text-black sm:absolute lg:relative translate-x-[-40%]'>
        اللغة
        </button>
        
        <div className ={press ? 'flex lg:flex-col lg:bg-gray sm:p-1 p-3 lang-box justify-between absolute sm:top-[34.2rem] sm:-left-[3rem] sm:translate-x-[-100%] transition-transform md:top-[81.7vh] lg:top-[4.5rem] lg:left-[80%] xl:left-[90%] xl:translate-x-[-7.5rem] rounded-lg' 
        : 'flex lg:flex-col sm:hidden lg:bg-gray sm:p-1 p-3 justify-between absolute sm:top-[33.9rem] sm:left-[30%] sm:translate-x-[-100%] md:top-[40rem] transition-transform lg:top-[4.5rem] lg:left-[1%] rounded-lg '} >

            <button  onClick={handleLanguageChangeA}
            className={
              lang ? ' border-[4px] m-2 sm:px-2 sm:py-1 sm:text-[16px] md:text-[1.5rem] lg:text-lg px-3 py-1 text-gray lg:text-black  md:px-4 md:py-2 lg:px-3 lg:py-1 rounded-lg border-white'
              : ' bg-white border-[4px] m-2 sm:px-2 sm:py-1 sm:text-[16px] md:text-[1.5rem] lg:text-lg  px-3 py-1 md:px-4 md:py-2 lg:px-3 lg:py-1 rounded-lg border-white'
            }>عربي</button>

            <button onClick={handleLanguageChangeB}
            className={
              lang ? ' bg-white m-2 sm:px-2 sm:py-1 sm:text-[16px] md:text-[1.5rem] lg:text-lg px-3 py-1 sm:text-black lg:text-black border-[4px] md:px-4 md:py-2 lg:px-3 lg:py-1 rounded-lg border-white'
              : 'm-2 sm:px-2 sm:py-1 sm:text-[16px] md:text-[1.5rem] lg:text-lg px-3 py-1 sm:text-gray lg:text-black border-[4px] md:px-4 md:py-2 lg:px-3 lg:py-1 rounded-lg border-white'
            }>English</button>
        </div>

    </div>
    </>
  );
};
// }

export default LangBtn;
